'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 24 24',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement(
                'g',
                { fill: 'none', fillRule: 'evenodd', stroke: 'none', strokeWidth: '1' },
                _react2.default.createElement('path', { d: 'M0 0h24v24H0z' }),
                _react2.default.createElement('path', {
                    d: 'M14.157 2a1.874 1.874 0 1 0 0 3.749 1.874 1.874 0 0 0 0-3.749zm-.45 5.96c-1.487.126-5.549 3.362-5.549 3.362-.25.188-.175.175.025.525.2.338.175.363.413.2.25-.162.662-.425 1.35-.85 2.649-1.699.424 2.225-.713 8.836-.45 3.274 2.5 1.587 3.262 1.087.75-.488 2.761-1.875 2.961-2.012.275-.188.075-.338-.137-.65-.15-.212-.3-.062-.3-.062-.812.537-2.3 1.662-2.5.95-.237-.713 1.288-5.6 2.125-8.96.137-.8.512-2.55-.937-2.425z',
                    fill: props.fill
                })
            )
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: '#000',
    width: '24px',
    height: '24px'
};

Icon.displayName = 'InfoItalic';

exports.default = Icon;